import RegisteredShareholder1099INT from './RegisteredShareholder1099INT';

export default RegisteredShareholder1099INT;

